import { SiTypescript, SiReact, SiNodedotjs, SiPostgresql } from 'react-icons/si';
 import { MdOutlinePaid  } from  'react-icons/md';
import NMULogo from '../images/NMULogo.png';

const featuredProjects = [
  {
    title: 'Northern Michigan University — Career Chronicles',
    description:
      'Serving as Lead Developer in partnership with Dr. Kow and NMU Career Services to design a university-wide gamified career tracking platform. Designed for 7,000+ students across multiple academic departments featuring role-based authorization, dynamic challenge engines, and a progressive web app (PWA) architecture for complete cross-platform functionality.',
    image: NMULogo,
    frameworks: [SiTypescript, SiReact, SiNodedotjs, SiPostgresql],
    type: 'Sponsored Institutional Project',
    typeIcon: <MdOutlinePaid />
  }
];

export default featuredProjects;
